<section class="no-access">
  <span class="material-symbols-outlined lock">lock</span>
  <h1>{{ 'access.noAccess.title' | translate }}</h1>

  @if (me()?.status === 'Aangevraagd') {
    <p>{{ 'access.noAccess.requested' | translate }}</p>
  } @else {
    <p>{{ 'access.noAccess.ask' | translate }}</p>
  }

  @if (me()?.email) {
    <p class="account">{{ 'access.noAccess.signedInAs' | translate }} <strong>{{ me()?.email }}</strong></p>
  }

  <div class="actions">
    <button mat-flat-button (click)="retry()">{{ 'access.noAccess.retry' | translate }}</button>
    <button mat-stroked-button (click)="logout()">
      <span class="material-symbols-outlined">logout</span>
      {{ 'topBar.logout' | translate }}
    </button>
  </div>
</section>
